import * as React from "react";
import { BaseComponent } from "../../../../../react-core/Html/BaseComponent";
import { CompanyWizardFilter } from "../Components/CompanyWizardFilter";
import { Dictionary } from "../../../../../react-core/Helpers/CommonHelper";
import { CompanyWizardStore } from "../Stores/Variable";
import { CompanyWizardAction } from "../Actions/CompanyWizardAction";
import { CompanyWizardTable } from "../Components/CompanyWizardTable";
import { GetFirmInstructionsQuery } from "../../../../../Wrap/Models/Models/Company/GetFirmInstructionsQuery";
import { InstructionStatus } from "../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { FirmInstructionHistoryCollectionModel } from "../../../../../Wrap/Models/Models/Company/FirmInstructionHistoryCollectionModel";
import { Alert } from "../../../../Shared/Components/Alert";
import { AlertType } from "../../../../Shared/Entities/Constants/AlertConstants";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { CancelFirmInstructionsQuery } from "../../../../../Wrap/Models/Models/Company/CancelFirmInstructionsQuery";
import { Lightbox, LightboxType } from "../../../../../react-core/Html/Components/Lightbox";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { checkPermission } from "../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
export type ICompanyWizardInProgressProps = React.Props<CompanyWizardInProgress>;

interface ICompanyWizardInProgressState {
    tableData: FirmInstructionHistoryCollectionModel;
    isLoading?: boolean;
    currentPage: number;
    pageSize: number;
    filter: any;
    displayAlert: boolean;
    alertType?: AlertType;
    alertMessage: string;
}

export class CompanyWizardInProgress extends FormComponent<
    ICompanyWizardInProgressProps,
    ICompanyWizardInProgressState
> {
    constructor(props: ICompanyWizardInProgressProps) {
        super(props);
        this.state = {
            tableData: null,
            isLoading: false,
            currentPage: 1,
            pageSize: 10,
            displayAlert: false,
            alertMessage: "",
            alertType: null,
            filter: {
                processType: 0,
                firmType: 0,
                firmName: "",
                reference: "",
                postcode: "",
                createdBy: null,
                dateStartedFrom: null,
                dateStartedTo: null,
                lastUpdatedFrom: null,
                lastUpdatedTo: null,
            },
        };
        this.subscribeToStore(CompanyWizardStore, () => this.onCompanyWizardStoreChange());
    }

    public render(): JSX.Element {
        if (!checkPermission(UserClaim.AdviserPortalNetworkAndFirmReadWrite)) {return null;}
        return (
            <>
                {this.renderFilter()}
                {this.renderAlert()}
                {this.renderTable()}
            </>
        );
    }

    private renderAlert() {
        const { alertMessage, alertType, displayAlert } = this.state;
        return displayAlert && <Alert alertType={alertType} message={alertMessage} />;
    }

    private renderTable(): JSX.Element {
        const { tableData, currentPage, pageSize, isLoading } = this.state;
        return (
            <>
                <CompanyWizardTable
                    tableData={tableData}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    isLoading={isLoading}
                    handlePageChange={this.handlePageChange}
                    inprogress={true}
                    handleSubmit={this.handleSubmit}
                />
            </>
        );
    }

    private renderFilter(): JSX.Element {
        const { filter } = this.state;
        return (
            <>
                <CompanyWizardFilter
                    processType={filter.processType}
                    firmType={filter.firmType}
                    firmName={filter.firmName}
                    reference={filter.reference}
                    postcode={filter.postcode}
                    createdBy={filter.createdBy}
                    dateStartedFrom={filter.dateStartedFrom}
                    dateStartedTo={filter.dateStartedTo}
                    lastUpdatedFrom={filter.lastUpdatedFrom}
                    lastUpdatedTo={filter.lastUpdatedTo}
                    handleFilterChange={this.handleFilterChange}
                    onSearch={this.onSearch}
                    displayNetworkSearch={false}
                />
            </>
        );
    }

    handleFilterChange = (changes: Dictionary[]) => {
        const updatedfilter = this.state.filter;
        for (const key in changes) {
            updatedfilter[key] = changes[key];
        }
        console.log(this.state.filter);
        this.setState({ filter: updatedfilter });
    };

    handlePageChange = (pageIndex: number) => {
        this.setState({ currentPage: pageIndex });
        this.getData(pageIndex);
    };

    private onCompanyWizardStoreChange() {
        const actiontype = CompanyWizardStore.getActionType();
        if (actiontype == ActionType.Update) {
            this.setState({ displayAlert: true, alertType: AlertType.Success, alertMessage: "Successfully deleted" });
        } else if (actiontype == ActionType.Error) {
            this.setState({ displayAlert: true, alertType: AlertType.Success, alertMessage: "Unable to delete" });
        }
        setTimeout(() => {
            this.setState({ displayAlert: false, alertMessage: "" });
        }, 5000);
        const data = CompanyWizardStore.getData();
        this.setState({ tableData: data, isLoading: false });
    }

    onSearch = () => {
        this.setState({ currentPage: 1 });
        this.getData(1);
    };

    private getData(pageIndex: number): void {
        const query = this.getQuery(pageIndex);
        this.setState({ isLoading: true });
        CompanyWizardAction.getCompanyWizardList(query);
    }

    private getQuery(pageIndex: number): GetFirmInstructionsQuery {
        const { filter, pageSize } = this.state;
        const start = (pageIndex - 1) * pageSize + 1;
        const count = pageSize;

        const query: GetFirmInstructionsQuery = {
            Statuses: [InstructionStatus.Pending],
            FirmProcessType: filter.processType,
            FirmType: filter.firmType,
            FirmName: filter.firmName,
            TradingReference: filter.reference,
            PostCode: filter.postcode,
            CreateUserId: filter.createdBy == "1" ? 1 : null,
            StartedFromDate: JsonDateParser.toJsonDateNoOffset(filter.dateStartedFrom),
            StartedToDate: JsonDateParser.toJsonDateNoOffset(filter.dateStartedTo),
            UpdatedFromDate: JsonDateParser.toJsonDateNoOffset(filter.lastUpdatedFrom),
            UpdatedToDate: JsonDateParser.toJsonDateNoOffset(filter.lastUpdatedTo),
            Start: start,
            Count: count,
        };
        return query;
    }

    handleSubmit = (ids: Array<number>) => {
        const query = this.getQuery(1);
        this.setState({ isLoading: true });
        const cancelquery: CancelFirmInstructionsQuery = {
            InstructionIds: ids,
        };
        CompanyWizardAction.deleteCompanyWizardList(cancelquery, () => {
            CompanyWizardAction.getCompanyWizardList(query);
        });
    };
}
